// styles/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* 1) 새 폰트 선언 */

  @font-face {
    font-family: 'Paperozi';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/2408-3@1.0/Paperlogy-7Bold.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
  }


  /* (기존) 보조 폰트 임포트 */
  @import url('https://cdn.jsdelivr.net/gh/wanteddev/wanted-sans@latest/packages/wanted-sans/fonts/webfonts/static/woff2/WantedSans.css');
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

  /* 2) 기본 폰트 스택 맨 앞에 추가 */
  * {
    font-family: 'Wanted Sans', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }



  html, body. #root {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden; 
    -webkit-text-size-adjust: 100%;
  }
    
  // html { scrollbar-gutter: stable both-edges; }

  body {
    font-family: 'Wanted Sans', 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6,
  .heading-display {               /* 필요 시 클래스도 제공 */
    font-family: 'Paperozi', 'Wanted Sans', 'Inter', sans-serif;
    font-weight: 700;             
  }

  a { text-decoration: none; color: inherit; border: none; outline: none; }
  button { border: none; background: none; cursor: pointer; font-family: inherit; outline: none; }
  ul, ol { list-style: none; }
  input:focus, textarea:focus, select:focus { outline: none; }
`;

export default GlobalStyle;
